/**
 * Active Role Manager
 * Gère la mise à jour du cookie activeRole en fonction de l'URL actuelle
 * Le cookie activeRole est utilisé par le backend pour sélectionner le bon token (membre/coach/admin)
 */

export const updateActiveRole = () => {
    const pathname = window.location.pathname
    let activeRole = 'member' // Valeur par défaut

    if (pathname.includes('/bva-coach/')) {
        activeRole = 'coach'
    } else if (pathname.includes('/bva-admin/')) {
        activeRole = 'admin'
    } else if (pathname.includes('/bva-membre/')) {
        activeRole = 'member'
    }

    document.cookie = `activeRole=${activeRole}; path=/; SameSite=Lax; max-age=86400`
    console.log('Active role cookie set to:', activeRole)
}
